export const CONTACT_PHONE = "+90 534 620 5605";
export const CONTACT_EMAIL = "info@tv13.com.tr";
export const CONTACT_ADDRESS =
  "Başarı Apartmanı, Kat 6 Daire 7 — Ayla Şimşek Danışmanlık Şirketi";
